import { forwardRef } from "react";

import dynamic from "next/dynamic";

import { CardProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardCard = dynamic(() => import("./DashboardCardSsr").then((mod) => mod.DashboardCardSsr), {
  ssr: false,
});

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
export const DashboardCard = forwardRef<HTMLDivElement, CardProps>((props, ref) => (
  <DynamicDashboardCard {...props} forwardedRef={ref} />
));

DashboardCard.displayName = "DashboardCard";
